import React, {useState} from 'react';
import {Form, IconTextButton} from '@xpertdox_js/xdcomponents';
import {btn_c_lightRed} from '@xpertdox_js/xdstyle';
import styles from './styles';

const FormInstance = props => {
  const [formState, setFormState] = useState({});

  return(
    <div style={styles.formContainer}>
      <Form
        submitable={false}
        settings={props.formSettings}
        formState={{formState, setFormState}}
        setStateCallback={props.setStateCallback}
      />
      <IconTextButton
        icon='x'
        text='Remove'
        preBuiltStyles={btn_c_lightRed}
        onClick={props.removeForm}
        size='sm'
      />
    </div>

  );
}

export default FormInstance;
